// extracted by mini-css-extract-plugin
export default {"wrapper":"richTextEditor_wrapper__99QeE"};